import lottie from 'lottie-web'
import emailjson from './../../../../lottie/email.json'

export function emailAnim() {
    const elementLotie = document.querySelector('.loader_sendemail .lottie_email')
    
    const emailAnim =  lottie.loadAnimation({
        container: elementLotie, // the dom element that will contain the animation
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: emailjson
      });
   return emailAnim
}

export function emailprocess(emailAnim){
        emailAnim.totalFrames = 1;
       
        emailAnim.playSegments([0,30],true);
        setTimeout(() => {
            emailAnim.playSegments([30,99],true);
            emailAnim.playSegments([30,99],true);   
            emailAnim.playSegments([30,99],true); 
        }, 1000);
        
}
export function emaildone(emailAnim){
    emailAnim.setSpeed(3)
    emailAnim.playSegments([99,197],true);
}

// import {emailAnim, emailprocess, emaildone} from '@/js/components/lottie/sendemail'